"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runColumns = runColumns;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _instants = require("web/shared/jobs/instants.js");
var _runStates = require("web/shared/jobs/runStates.js");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _cells = require("web/shared/jobs/cells");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* What a run table shows about each attempt.
*
* The job column is a parameter rather than a fixed column: a job's own
* history has the job in its heading already, where a dispatch's runs need it
* on every row.
*/
function runColumns(showJob) {
  const jobColumn = showJob ? [{
    key: "job",
    header: "Job",
    render: run => (0, _cells.monoCell)(run.jobKey)
  }] : [];
  return [{
    key: "run",
    header: "Run #",
    align: "right",
    render: run => (0, _cells.monoCell)(String(run.sequentialRunId))
  }, ...jobColumn, {
    key: "state",
    header: "State",
    render: run => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.pill, (0, _runStates.runStateStyle)(run.state))), {}, {
      children: run.state.toLowerCase()
    }))
  }, {
    key: "date",
    header: "Date",
    render: run => (0, _cells.monoCell)((0, _instants.formatDate)(run.startedAt))
  }, {
    key: "started",
    header: "Started",
    render: run => (0, _cells.monoCell)((0, _instants.formatTime)(run.startedAt))
  }, {
    key: "ended",
    header: "Ended",
    render: run => (0, _cells.monoCell)((0, _instants.formatTime)(run.finishedAt))
  }, {
    key: "duration",
    header: "Duration",
    align: "right",
    render: run => (0, _cells.monoCell)((0, _instants.formatDuration)(run.startedAt, run.finishedAt))
  }, {
    key: "dispatch",
    header: "Dispatch #",
    align: "right",
    render: run => (0, _cells.monoCell)(run.sequentialDispatchId == null ? "—" : String(run.sequentialDispatchId))
  }, {
    key: "detail",
    header: "Detail",
    render: run => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.stackedCell)), {}, {
      children: [run.retryOfRunId != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.pill, _jobsViewsStyles.styles.pillMuted)), {}, {
        children: "retry"
      })) : null, run.error != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.errorText)), {}, {
        children: run.error
      })) : null]
    }))
  }];
}